<template>
<div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="流程设置" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
                                <el-form-item label="流程名称">
                                    <el-input v-model="searchForm.flow_name" placeholder="请填写流程名称" clearable></el-input>
                                </el-form-item>
								<el-form-item label="流程分类">
								  <el-select v-model="searchForm.type_id" placeholder="请选择" clearable>
								    <el-option
								      v-for="item in options.type_options"
								      :key="item.id"
								      :label="item.name"
								      :value="item.id"
								    ></el-option>
								  </el-select>
								</el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                                    <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;">
                                <div>
                                    <el-button type="primary" size="mini" @click="addFlowOpen">添加审批流</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table
                                    :data="tableData.data"
                                    style="width: 100%"
                                    row-key="id"
                                    border
                                    stripe
                                    ref = "table"
                                    highlight-current-row
                                    @sort-change="sortChange"
                                    :height="tableHeight">
									<el-table-column
									        fixed
									        prop="id"
									        label="ID"
									        min-width="50">
									</el-table-column>
                                <el-table-column
                                        fixed
                                        prop="flow_name"
                                        label="流程名称"
                                        min-width="200">
                                </el-table-column>
								<el-table-column
								        prop="type_name"
								        label="分类名称"
								        min-width="200">
								</el-table-column>
								<el-table-column
								        prop="form_name"
								        label="表单名称"
								        min-width="200">
								</el-table-column>
                                <el-table-column
                                        prop="is_open"
                                        label="是否启用"
                                        width="100">
										<template slot-scope="scope">
										  <el-tag :size="size" v-if="scope.row.is_open == '1'" type="success">启用</el-tag>
										  <el-tag :size="size" v-if="scope.row.is_open == '2'" type="danger">停用</el-tag>
										</template>
                                </el-table-column>
                                <el-table-column
                                        prop="is_lock"
                                        label="是否可删除"
                                        width="100">
										<template slot-scope="scope">
										  <el-tag :size="size" v-if="scope.row.is_lock == '1'" type="success">可删除</el-tag>
										  <el-tag :size="size" v-if="scope.row.is_lock == '2'" type="danger">不可删除</el-tag>
										</template>
                                </el-table-column>
                                <el-table-column
                                        prop="create_time"
                                        label="创建时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="update_time"
                                        label="修改时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                        min-width="220">
                                    <template slot-scope="scope">
                                        <el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size">编辑</el-button>
										<el-button v-if="scope.row.is_open == '2'" @click="handleTableChangeShow(scope.row)" type="text" :size="size">启用</el-button>
										<el-button v-else @click="handleTableChangeShow(scope.row)" type="text" :size="size">停用</el-button>
										<el-button @click="handleTableSet(scope.row)" type="text" :size="size">添加审批节点</el-button>
                                        <el-button v-if="scope.row.is_lock == 1" @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger">
                                            删除
                                        </el-button>
																				<!-- <el-button @click="forcedReturn(scope.row)" type="text" :size="size" class="c-danger">
                                            强制退回
                                        </el-button> -->
                                    </template>
                                </el-table-column>
                            </el-table>
							<el-pagination
								background
								ref="pagination"
								@current-change="handleCurrentChange"
								:current-page="tableData.page | number"
								:page-size="tableData.pagesize | number"
								layout="prev, pager, next, total"
								:total="tableData.total | number">
							</el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    <!-- 添加流程 -->
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="addFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>添加流程</span>
                    <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
				<el-form-item label="流程名称" prop="flow_name">
					<el-input v-model="addForm.flow_name" placeholder="请填写流程名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="流程分类" prop="type_id">
					<el-select v-model="addForm.type_id" placeholder="请选择">
					  <el-option
					    v-for="item in options.type_options"
					    :key="item.id"
					    :label="item.name"
					    :value="item.id"
					  ></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="表单" prop="form_id">
					<el-select v-model="addForm.form_id" placeholder="请选择">
					  <el-option
					    v-for="item in options.form_options"
					    :key="item.id"
					    :label="item.fname"
					    :value="item.id"
					  ></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否启用" prop="is_open">
					<el-radio v-model="addForm.is_open" :label="1">启用</el-radio>
					<el-radio v-model="addForm.is_open" :label="2">停用</el-radio>
				</el-form-item>
				<el-form-item label="是否可删除" prop="is_lock">
					<el-radio v-model="addForm.is_lock" :label="1">可删除</el-radio>
					<el-radio v-model="addForm.is_lock" :label="2">不可删除</el-radio>
				</el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="addFlow" :size='size'>提交</el-button>
                <el-button :size='size' @click="addFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    <!-- 编辑流程 -->
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="editFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>编辑流程</span>
                    <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-form-item label="流程名称" prop="flow_name">
                	<el-input v-model="editForm.flow_name" placeholder="请填写流程名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="流程分类" prop="type_id">
                	<el-select v-model="editForm.type_id" placeholder="请选择">
                	  <el-option
                	    v-for="item in options.type_options"
                	    :key="item.id"
                	    :label="item.name"
                	    :value="item.id"
                	  ></el-option>
                	</el-select>
                </el-form-item>
                <el-form-item label="表单" prop="form_id">
                	<el-select v-model="editForm.form_id" placeholder="请选择">
                	  <el-option
                	    v-for="item in options.form_options"
                	    :key="item.id"
                	    :label="item.fname"
                	    :value="item.id"
                	  ></el-option>
                	</el-select>
                </el-form-item>
                <el-form-item label="是否启用" prop="is_open">
                	<el-radio v-model="editForm.is_open" :label="1">启用</el-radio>
                	<el-radio v-model="editForm.is_open" :label="2">停用</el-radio>
                </el-form-item>
                <el-form-item label="是否可删除" prop="is_lock">
                	<el-radio v-model="editForm.is_lock" :label="1">可删除</el-radio>
                	<el-radio v-model="editForm.is_lock" :label="2">不可删除</el-radio>
                </el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="editFlow" :size='size'>提交</el-button>
                <el-button :size='size' @click="editFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
	<!-- 添加审批节点 -->
	<el-drawer
	    custom-class="k-drawer"
	    :visible.sync="addStepVisiable"
	    direction="rtl"
	    size="80%">
		<div class="drawer-header">
			<div class="header-title">
				<span>添加审批节点</span>
				<i class="el-icon-close k-drawer-close" @click="addStepVisiable = false"></i>
			</div>
		</div>
		<div class="drawer-content">
			<h3 class="lineH3">审批流详情</h3>
			<ul class="detail">
				<li>
					<span>流程名称</span>
					<p>{{flowData.flow_name}}</p>
				</li>
				<li>
					<span>分类名称</span>
					<p>{{flowData.type_name}}</p>
				</li>
				<li>
					<span>表单名称</span>
					<p>{{flowData.form_name}}</p>
				</li>
				<li>
					<span>是否启用</span>
					<p>
						<template v-if="flowData.is_open == '1'">启用</template>
						<template v-if="flowData.is_open == '2'">停用</template>
					</p>
				</li>
				<li>
					<span>是否可删除</span>
					<p>
						<template v-if="flowData.is_lock == '1'">可删除</template>
						<template v-if="flowData.is_lock == '2'">不可删除</template>
					</p>
				</li>
				<li>
					<span>创建时间</span>
					<p>{{flowData.create_time}}</p>
				</li>
				<li>
					<span>修改时间</span>
					<p>{{flowData.update_time}}</p>
				</li>
			</ul>
			<el-button type="primary" @click="addFlowStepopen" :size='size'>添加审批节点</el-button>
			<el-timeline style="margin-top: 40px;" v-loading="loading">
			    <el-timeline-item 
					v-for="(item, index) in flowStepData"
					:key="index">
			      <el-card>
				    <div class="option">
					  <el-link type="primary" @click="moveUp(index)">上移</el-link>
					  <el-link type="primary" @click="moveDown(index)">下移</el-link>
					  <el-link type="warning" @click="editFlowStepopen(item.id)">编辑</el-link>
					  <el-link type="danger" @click="delFlowStep(item.id)">删除</el-link>
				    </div>
					<ul class="detail">
						<li>
							<span>节点名称</span>
							<p>{{item.step_name}}</p>
						</li>
						<li>
							<span>审核类型</span>
							<p>{{item.checktype_name}}</p>
						</li>
						<li>
							<span>指定人/分组</span>
							<p>{{item.appoint_name}}</p>
						</li>
						<li>
							<span>支持多人审批</span>
							<p>
								<template v-if="item.is_approved == '1'">否</template>
								<template v-if="item.is_approved == '2'">是</template>
							</p>
						</li>
						<li v-if="item.is_approved == '2'">
							<span>审核通过占比</span>
							<p>{{item.approved_ratio}}</p>
						</li>
						<li>
							<span>跳过节点</span>
							<p>{{item.skip_name ? item.skip_name : '暂无'}}</p>
						</li>
						<li style="width: 100%;">
							<span>可执行操作</span>
							<p>{{item.operation_name}}</p>
						</li>
						<li style="width: 100%;">
							<span>流程说明</span>
							<p>{{item.flow_desc ? item.flow_desc : '暂无'}}</p>
						</li>
					</ul>
			      </el-card>
			    </el-timeline-item>
			</el-timeline>
		</div>
	</el-drawer>
	<!--添加节点-->
	<el-dialog
	  title="添加节点"
	  :visible.sync="addFlowstepFormVisiable"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	  width="50%">
		  <el-form :model="addStepForm" ref="addStepForm" :size="size" :rules="rules.addStepForm" label-width="130px">
			  <div>
				  <el-form-item label="节点名称" prop="step_name">
					<el-input v-model="addStepForm.step_name" placeholder="请填写节点名称" clearable></el-input>
				  </el-form-item>
				  <el-form-item label="审核类型" prop="checktype_id">
				  	<el-select v-model="addStepForm.checktype_id" placeholder="请选择" style="width: 100%;" @change="checktypeChange">
				  	  <el-option
				  	    v-for="item in options.checktype_options"
				  	    :key="item.id"
				  	    :label="item.name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="指定人" prop="appoint_id" v-if="addStepForm.checktype_id == 4">
				  	<el-select v-model="addStepForm.appoint_id" placeholder="请选择" style="width: 100%;" multiple>
				  	  <el-option
				  	    v-for="item in options.user_options"
				  	    :key="item.id"
				  	    :label="item.user_name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="指定分组" prop="appoint_id" v-if="addStepForm.checktype_id == 5">
				  	<el-select v-model="addStepForm.appoint_id" placeholder="请选择" style="width: 100%;">
				  	  <el-option
				  	    v-for="item in options.group_options"
				  	    :key="item.id"
				  	    :label="item.group_name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="可执行操作" prop="operation_ids">
				  	<el-select v-model="addStepForm.operation_ids" placeholder="请选择" style="width: 100%;" multiple>
				  	  <el-option
				  	    v-for="item in options.operation_options"
				  	    :key="item.id"
				  	    :label="item.name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="跳过该节点条件">
				  	<el-select v-model="addStepForm.skip_id" placeholder="请选择" style="width: 100%;" clearable>
				  	  <el-option
				  	    v-for="item in options.skip_options"
				  	    :key="item.id"
				  	    :label="item.name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="是否支持多人审批" prop="is_approved">
				  	<el-radio v-model="addStepForm.is_approved" :label="1">否</el-radio>
				  	<el-radio v-model="addStepForm.is_approved" :label="2">是</el-radio>
				  </el-form-item>
				  <el-form-item label="审核通过占比" prop="approved_ratio" v-if="addStepForm.is_approved == 2">
				  	<el-input v-model="addStepForm.approved_ratio" placeholder="请填写审核通过占比(格式:百分比,例如:60%)" clearable></el-input>
				  </el-form-item>
				  <el-form-item label="审批节点说明" prop="fdesc">
				  	<el-input type="textarea" v-model="addForm.fdesc" placeholder="请填写审批节点说明" clearable>
				  	</el-input>
				  </el-form-item>
			  </div>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="addFlowstep" :size='size'>提交</el-button>
			<el-button :size='size' @click="addFlowstepFormVisiable = false">取消</el-button>
		  </span>
	</el-dialog>
	<!--编辑审批节点-->
	<el-dialog
	  title="编辑审批节点"
	  :visible.sync="editFlowstepFormVisiable"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	  width="50%">
		  <el-form :model="editStepForm" ref="editStepForm" :size="size" :rules="rules.editStepForm" label-width="130px" v-loading="loading">
			  <div>
				  <el-form-item label="节点名称" prop="step_name">
					<el-input v-model="editStepForm.step_name" placeholder="请填写节点名称" clearable></el-input>
				  </el-form-item>
				  <el-form-item label="审核类型" prop="checktype_id">
				  	<el-select v-model="editStepForm.checktype_id" placeholder="请选择" style="width: 100%;" @change="checktypeChange">
				  	  <el-option
				  	    v-for="item in options.checktype_options"
				  	    :key="item.id"
				  	    :label="item.name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="指定人" prop="appoint_id" v-if="editStepForm.checktype_id == 4">
				  	<el-select v-model="editStepForm.appoint_id" placeholder="请选择" style="width: 100%;" multiple>
				  	  <el-option
				  	    v-for="item in options.user_options"
				  	    :key="item.id"
				  	    :label="item.user_name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="指定分组" prop="appoint_id" v-if="editStepForm.checktype_id == 5">
				  	<el-select v-model="editStepForm.appoint_id" placeholder="请选择" style="width: 100%;">
				  	  <el-option
				  	    v-for="item in options.group_options"
				  	    :key="item.id"
				  	    :label="item.group_name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="可执行操作" prop="operation_ids">
				  	<el-select v-model="editStepForm.operation_ids" placeholder="请选择" style="width: 100%;" multiple>
				  	  <el-option
				  	    v-for="item in options.operation_options"
				  	    :key="item.id"
				  	    :label="item.name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="跳过该节点条件">
				  	<el-select v-model="editStepForm.skip_id" placeholder="请选择" style="width: 100%;" clearable>
				  	  <el-option
				  	    v-for="item in options.skip_options"
				  	    :key="item.id"
				  	    :label="item.name"
				  	    :value="item.id"
				  	  ></el-option>
				  	</el-select>
				  </el-form-item>
				  <el-form-item label="是否支持多人审批" prop="is_approved">
				  	<el-radio v-model="editStepForm.is_approved" :label="1">否</el-radio>
				  	<el-radio v-model="editStepForm.is_approved" :label="2">是</el-radio>
				  </el-form-item>
				  <el-form-item label="审核通过占比" prop="approved_ratio" v-if="editStepForm.is_approved == 2">
				  	<el-input v-model="editStepForm.approved_ratio" placeholder="请填写审核通过占比(格式:百分比,例如:60%)" clearable></el-input>
				  </el-form-item>
				  <el-form-item label="审批节点说明" prop="fdesc">
				  	<el-input type="textarea" v-model="editStepForm.fdesc" placeholder="请填写审批节点说明" clearable>
				  	</el-input>
				  </el-form-item>
			  </div>
		  </el-form>
		  <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="editFlowStep" :size='size'>提交</el-button>
			<el-button :size='size' @click="editFlowstepFormVisiable = false">取消</el-button>
		  </span>
	</el-dialog>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
		  addStepVisiable:false,
		  addFlowstepFormVisiable:false,
		  editFlowstepFormVisiable:false,
          activeName: 'first',
          size:'mini',
		  loading:false,
          options: {
              form_options: [],
			  type_options: [],
			  checktype_options:[],
			  operation_options:[],
			  skip_options:[],
			  user_options:[],
			  group_opitons:[]
          },
          searchForm: {
              flow_name: '',
			  type_id:''
          },
          resetSearch: {
              flow_name: '',
              type_id:''
          },
          addForm: {
              flow_name: '',
              type_id: '',
              form_id:'',
              is_open:'',
              is_lock:''
          },
          editForm: {
              flow_name: '',
              type_id: '',
              form_id:'',
              is_open:'',
              is_lock:''
          },
		  stepForm:{
			  step_name:''
		  },
		  addStepForm:{
			  flow_set_id:'',
			  step_name:'',
			  checktype_id:'',
			  appoint_id:'',
			  is_approved:1,
			  approved_ratio:'',
			  operation_ids:'',
			  skip_id:'',
			  flow_desc:''
		  },
		  editStepForm:{
			  flow_set_id:'',
			  step_name:'',
			  checktype_id:'',
			  appoint_id:'',
			  is_approved:'',
			  approved_ratio:'',
			  operation_ids:'',
			  skip_id:'',
			  flow_desc:''
		  },
		  flow_set_id:'',
		  flowData:{},
		  flowStepData:[],
          rules: {
              addForm: {
                  'flow_name': [
                      {required: true, message: '请填写流程名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的流程名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'type_id': [
                      {required: true, message: '请选择流程分类', trigger: ['change']}
                  ],
				  'form_id': [
				      {required: true, message: '请选择表单', trigger: ['change']}
				  ],
				  'is_open': [
				      {required: true, message: '请选择是否启用', trigger: ['change']}
				  ],
				  'is_lock': [
				      {required: true, message: '请选择是否可删除', trigger: ['change']}
				  ]
              },
              editForm: {
                  'flow_name': [
                      {required: true, message: '请填写流程名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的流程名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'type_id': [
                      {required: true, message: '请选择流程分类', trigger: ['change']}
                  ],
                  'form_id': [
                      {required: true, message: '请选择表单', trigger: ['change']}
                  ],
                  'is_open': [
                      {required: true, message: '请选择是否启用', trigger: ['change']}
                  ],
                  'is_lock': [
                      {required: true, message: '请选择是否可删除', trigger: ['change']}
                  ]
              },
			  stepForm: {
				  'step_name': [
				      {required: true, message: '请填写节点名称', trigger: ['change', 'blur']},
				      {max: 50, message: '请填写正确的节点名称，长度不超过 50', trigger: ['change', 'blur']}
				  ],
			  },
			  addStepForm: {
				  'step_name': [
				      {required: true, message: '请填写审批节点名称', trigger: ['change', 'blur']},
				      {max: 50, message: '请填写正确的审批节点名称，长度不超过 50', trigger: ['change', 'blur']}
				  ],
				  'checktype_id': [
				      {required: true, message: '请选择审核类型', trigger: ['change']}
				  ],
				  'appoint_id': [
				      {required: true, message: '请选择指定人员', trigger: ['change']}
				  ],
				  'operation_ids': [
				      {required: true, message: '请选择可执行操作条件', trigger: ['change']}
				  ],
				  'flow_desc': [
				      {required: true, message: '请填写审批节点说明', trigger: ['change', 'blur']},
				      {max: 100, message: '请填写正确的审批节点说明，长度不超过 100', trigger: ['change', 'blur']}
				  ],
				  'approved_ratio': [
					  {required: true, message: '请填写审核通过占比', trigger: ['change', 'blur']},
				  ]
				  
			  },
			  editStepForm: {
				  'step_name': [
					  {required: true, message: '请填写审批节点名称', trigger: ['change', 'blur']},
					  {max: 50, message: '请填写正确的审批节点名称，长度不超过 50', trigger: ['change', 'blur']}
				  ],
				  'checktype_id': [
					  {required: true, message: '请选择审核类型', trigger: ['change']}
				  ],
				  'appoint_id': [
				      {required: true, message: '请选择指定人员', trigger: ['change']}
				  ],
				  'operation_ids': [
					  {required: true, message: '请选择可执行操作条件', trigger: ['change']}
				  ],
				  'flow_desc': [
					  {required: true, message: '请填写审批节点说明', trigger: ['change', 'blur']},
					  {max: 100, message: '请填写正确的审批节点说明，长度不超过 100', trigger: ['change', 'blur']}
				  ],
				  'approved_ratio': [
					  {required: true, message: '请填写审核通过占比', trigger: ['change', 'blur']},
				  ]
			  				  
			  }
          },
          tableData: {
              total: 0,
              pagesize: 15,
              page: 1,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      }
  },
  mounted: function () {
      this.handleSearch(this.searchForm)
	  this.getTypeFormOption()
  },
  methods: {
		//列表查询
		handleSearch(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/examine/flowset/list',param).then(res => {
			   if (res.code == 0) {
				   this.tableData = res.data;		
			   }else{
				   this.$message.error(res.msg);
			   }
			})
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange(e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
			  order = 'asc';
			} else if (e.order == 'descending') {
			  order = 'desc';
			} else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加菜单弹窗
		addFlowOpen(){
			this.addForm = {
              flow_name: '',
              type_id: '',
              form_id:'',
              is_open:'',
              is_lock:''
          },
			this.getTypeFormOption()
			this.$nextTick(() => {
			  this.$refs['addForm'].clearValidate();
			});
			this.addFormVisiable = true;
		},
		// 添加流程
		addFlow() {
		  this.$refs['addForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/examine/flowset/add',this.addForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '流程添加成功！',
							  type: 'success'
						  });
						  this.addFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
		
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		//编辑流程弹窗
		handleTableEditOpen(row){
			this.$api.get('/admin/examine/flowset/info',{id:row.id}).then(res => {
				  if (res.code == 0) {
					  this.editForm = res.data.data
					  this.getTypeFormOption()
					  this.editFormVisiable = true;
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		//编辑流程
		editFlow(){
			this.$refs['editForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.put('/admin/examine/flowset/edit',this.editForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '流程信息修改成功！',
							  type: 'success'
						  });
						  this.editFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
			}.bind(this));
		},
		//获取分类及表单下拉
		getTypeFormOption(id){
			this.$api.get('/admin/examine/flowset/typeform',{id:id ? id : ''}).then(res => {
				if (res.code === 0) {
				  this.options.type_options = res.data.type;
				  this.options.form_options = res.data.form
				} else {
				  this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//删除
		handleTableDelete(row){
			this.$confirm('此操作将永久删除该流程, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/examine/flowset/del', {id:row.id}).then(res => {
				  if (res.code == 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == row.id) {
							  this.$delete(data, index);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == row.id) {
									  this.$delete(item.children, key);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该流程已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
			}.bind(this))
		},
		//修改流程启用状态
		handleTableChangeShow: function (row) {
		  this.$confirm('此操作将修改该流程的启用状态, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
		  }).then(function() {
			  this.loading = true;
			  let openStatu = row.is_open
			  this.$api.put('/admin/examine/flowset/isshow',{id:row.id,open:openStatu == 1 ? 2 : 1}).then(res => {
				  if (res.code == 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == res.data.id) {
							  this.$set(data, index, res.data);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == res.data.id) {
									  this.$set(item.children, key, res.data);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					
					  this.$message({
						  showClose: true,
						  message: '流程状态修改成功！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
		  }.bind(this))
		},
		//设置步骤
		handleTableSet(row){
			this.flowData = row
			this.flow_set_id = row.id
			this.addStepVisiable = true
			this.getFlowstepList()//获取审批节点列表
		},
		//新增审批节点弹窗
		addFlowStepopen(){
			this.getChecktypeOption()//获取审核类型、可执行操作、跳过步骤
			this.addStepForm = {
			  flow_set_id:this.flow_set_id,
			  step_name:'',
			  checktype_id:'',
			  appoint_id:'',
			  is_approved:1,
			  approved_ratio:'',
			  operation_ids:'',
			  skip_id:'',
			  flow_desc:''
			}
			this.$nextTick(() => {
			  this.$refs['addStepForm'].clearValidate();
			});
			this.addFlowstepFormVisiable = true
		},
		//添加审批节点
		addFlowstep(){
			this.$refs['addStepForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/examine/flowstep/add',this.addStepForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.getFlowstepList();
						  this.$message({
							  showClose: true,
							  message: '审批节点添加成功！',
							  type: 'success'
						  });
						  this.addFlowstepFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
		
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		//获取审核类型、可执行操作、跳过步骤
		getChecktypeOption(type,id){
			this.$api.get('/admin/examine/flowstep/checktype').then(res => {
				if (res.code === 0) {
				  this.options.checktype_options = res.data.checktype;
				  this.options.operation_options = res.data.operation
				  this.options.skip_options = res.data.skip
				  this.options.user_options = res.data.user
				  this.options.group_options = res.data.group
				  if(type == "edit"){
					  this.getFlowstepInfo(id)
				  }
				} else {
				  this.$notify({
					  showClose: true,
					  message: res.msg,
					  type: 'warning'
				  });
				}
				this.loading = false
			})
		},
		//获取审批节点列表
		getFlowstepList(){
			this.loading = true
			let that = this
			this.$api.get('/admin/examine/flowstep/list',{flow_set_id:this.flow_set_id}).then(res => {
				if (res.code === 0) {
				   this.flowStepData = res.data
				} else {
				  this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//上移
		moveUp(index){
			if(index>0){
				const temp = this.flowStepData[index - 1];
				this.$set(this.flowStepData, index - 1, this.flowStepData[index]);
				this.$set(this.flowStepData, index, temp);
				
				let moveid = []
				this.flowStepData.forEach((item,index) => {
					moveid.push(item.id)
				})
				this.$api.put('/admin/examine/flowstep/order',{flow_set_id:this.flow_set_id,id:moveid}).then(res => {
				  if (res.code === 0) {
				  } else {
					  this.$message.error(res.msg);
				  }
				})
			}else{
				this.$notify({
				  showClose: true,
				  message: "已经是第一步了",
				  type: 'warning'
				})
			}
		},
		//下移
		moveDown(index){
			if(index < this.flowStepData.length - 1){
				const temp = this.flowStepData[index + 1];
				this.$set(this.flowStepData, index + 1, this.flowStepData[index]);
				this.$set(this.flowStepData, index, temp);
				
				let moveid = []
				this.flowStepData.forEach((item,index) => {
					moveid.push(item.id)
				})
				this.$api.put('/admin/examine/flowstep/order',{flow_set_id:this.flow_set_id,id:moveid}).then(res => {
				  if (res.code === 0) {
				  } else {
					  this.$message.error(res.msg);
				  }
				})
			}else{
				this.$notify({
				  showClose: true,
				  message: "已经是最后一步了",
				  type: 'warning'
				})
			}
		},
		//打开编辑审批节点弹窗
		editFlowStepopen(id){
			this.editFlowstepFormVisiable = true
			this.getChecktypeOption('edit',id)
		},
		getFlowstepInfo(id){
			this.$api.get('/admin/examine/flowstep/info',{id:id}).then(res => {
				  if (res.code === 0) {
					  this.editStepForm = res.data.data
					  if(this.editStepForm.skip_id == 0){
						  this.editStepForm.skip_id = ''
					  }
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		editFlowStep(){
			this.$refs['editStepForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.put('/admin/examine/flowstep/edit',this.editStepForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.getFlowstepList();
						  this.$message({
							  showClose: true,
							  message: '审批节点信息修改成功！',
							  type: 'success'
						  });
						  this.editFlowstepFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
			}.bind(this));
		},
		//删除审批节点
		delFlowStep(id){
			this.$confirm('此操作将永久删除该审批节点, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/examine/flowstep/del', {id:id}).then(res => {
				  if (res.code === 0) {
					  var data = this.flowStepData;
					  data.forEach(function (item, index) {
						  if (item.id == id) {
							  this.$delete(data, index);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == id) {
									  this.$delete(item.children, key);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该审批节点已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
			}.bind(this))
		},
		//切换审核类型
		checktypeChange(){
			this.addStepForm.appoint_id = ''
			this.editStepForm.appoint_id = ''
		}
    }
}
</script>
<style lang="scss" scoped>
	.lineH3{
		font-size: 16px;
		padding-left: 12px;
		position: relative;
		line-height: 38px;
		&:before {
		    content: "";
		    display: inline-block;
		    width: 3px;
		    border-radius: 15px;
		    height: 18px;
		    background-color: #409EFF;
			position: absolute;
			left: 0;
			top: 10px;
		}
	}
	.detail{
		display: flex;
		flex-wrap: wrap;
		padding:10px 0 40px;
		line-height: 26px;
		li{
			width: 33.33%;
			display: flex;
			justify-content: flex-start;
			font-size:14px;
			span{
				width: 100px;
				padding-right: 10px;
				box-sizing: border-box;
				display: inline-flex;
				justify-content: right;
				color: #a1a1a1;
			}
			p{
				flex: 1;
				text-align: left;
				color: #333;
			}
		}
	}
	.k-drawer .el-drawer__body .drawer-content {
		height: calc(100vh - 82px);
	}
	.el-timeline-item{
		padding-bottom: 60px;
		&:last-of-type{
			padding-bottom: 20px;
		}
	}
	.option{
		position: absolute;
		display: flex;
		justify-content: flex-end;
		top: -30px;
		right: 0;
		.el-link{
			margin: 0 10px 0 0;
		}
	}
</style>